import { useState } from 'react';
import { Outlet } from 'react-router-dom';

import { useSidebarStore } from '@web/app/shared';
import { Header } from '@web/app/shared/components/Header';

import { useWebCoreStore } from '@codes/web-core';

import { Footer } from './Footer';
import { SideNav } from './side-nav';

export const DefaultLayout = () => {
    const isAuthenticated = useWebCoreStore(state => state.isAuthenticated);
    const { isSidebarOpen, setIsSidebarOpen } = useSidebarStore();
    const [footerHeight, setFooterHeight] = useState(0);

    if (isAuthenticated) {
        return (
            <div className="min-w-[320px] min-h-screen flex w-full" style={{ marginBottom: `${footerHeight}px` }}>
                <SideNav isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} />
                <div
                    className={`flex flex-1 min-h-screen bg-background mx-auto flex-col transition-all duration-300 ease-in-out max-sm:pl-0 ${
                        isSidebarOpen ? 'pl-60' : 'pl-0'
                    }`}
                >
                    <Header isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} />
                    <div className="pt-[56px] flex-1 flex flex-col relative z-10">
                        <Outlet />
                    </div>
                    <div
                        className={`fixed bottom-0 -z-0 ${
                            isSidebarOpen ? 'w-[calc(100%-240px)] max-sm:w-full' : 'w-full'
                        }`}
                    >
                        <Footer setFooterHeight={setFooterHeight} />
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="min-w-[320px] min-h-screen flex w-full" style={{ marginBottom: `${footerHeight}px` }}>
            <div className="flex flex-1 min-h-screen bg-background mx-auto flex-col transition-all duration-300 ease-in-out max-sm:pl-0 pl-0">
                <Header isSidebarOpen={false} setIsSidebarOpen={setIsSidebarOpen} />
                <div className="pt-[56px] flex-1 flex flex-col relative z-10">
                    <Outlet />
                </div>
                <div className="fixed bottom-0 -z-0 w-full">
                    <Footer setFooterHeight={setFooterHeight} />
                </div>
            </div>
        </div>
    );
};
